import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { waitFor, modifyProps } from 'lp-hoc'
import { AccountForm } from '../forms'
import * as apiActions from 'api-actions'
import * as Types from 'types'
import { selectors as globalArtistSelectors } from 'artist-portal-reducer'
import { selectors as globalSelectors } from 'reducer'
import * as globalActions from 'artist-portal-actions'
import * as flashActions from 'redux-flash'
import { displaySubmitFailure, useCommunity } from 'utils'
import { camelCase } from 'lodash'
import syncProfileCompletion from '../sync-profile-completion'

const propTypes = {
  artist: Types.artist.isRequired,
  flashSuccessMessage: PropTypes.func.isRequired,
  flashErrorMessage: PropTypes.func.isRequired,
  currentArtistLocation: PropTypes.oneOfType([
    Types.location,
    PropTypes.oneOf([null]),
  ]),
  setArtist: PropTypes.func.isRequired,
  updateArtist: PropTypes.func.isRequired,
  demographics: PropTypes.arrayOf(Types.demographic).isRequired,
  currentSchoolYear: Types.schoolYear,
}

const defaultProps = {}

function Account({
  flashSuccessMessage,
  flashErrorMessage,
  currentArtistLocation,
  updateArtist,
  setArtist,
  artist,
  demographics,
  currentSchoolYear,
}) {
  const community = useCommunity()
  const { teachingArtistProfileCompletionEnabled } = community

  // Transform badges array into individual form field values
  const badgeValues = (artist.badges || []).reduce((acc, badge) => {
    acc[camelCase(badge.name)] = badge.active
    return acc
  }, {})

  return (
    <AccountForm
      profileCompletionRequired={teachingArtistProfileCompletionEnabled}
      initialValues={{ ...artist, ...badgeValues }}
      onSubmit={updateArtist}
      onSubmitSuccess={(updatedArtist) => {
        setArtist(updatedArtist)
        syncProfileCompletion({
          artist: updatedArtist,
          previousArtist: artist,
          community,
          updateArtistBadge: updateArtist,
          currentSchoolYearId: currentSchoolYear && currentSchoolYear.id,
        })
        flashSuccessMessage('Artist information updated!')
      }}
      onSubmitFail={displaySubmitFailure}
      currentArtistLocation={currentArtistLocation}
      flashErrorMessage={flashErrorMessage}
      flashSuccessMessage={flashSuccessMessage}
      artistId={artist.id}
      demographics={demographics}
      badges={artist.badges || []}
    />
  )
}

Account.propTypes = propTypes
Account.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    artist: globalArtistSelectors.artist(state),
    currentArtistLocation: globalArtistSelectors.currentArtistLocation(state),
    demographics: globalSelectors.demographics(state),
    currentSchoolYear: globalSelectors.currentSchoolYear(state),
  }
}

const mapDispatchToProps = {
  flashSuccessMessage: flashActions.flashSuccessMessage,
  flashErrorMessage: flashActions.flashErrorMessage,
  setArtist: globalActions.setArtist,
  updateArtist: apiActions.updateArtist,
}

function modify({ artist, currentSchoolYear, updateArtist }) {
  return {
    updateArtist: (params) =>
      updateArtist(artist.id, currentSchoolYear.id, params),
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  waitFor(['artist']),
  modifyProps(modify)
)(Account)
